import Vue from 'vue'
import Router from 'vue-router'

const Login = () => import('@/views/Login')
const Main = () => import('@/views/Main')
const Doc = () => import('@/views/Doc')

const Register = () => import('@/views/account/Register')
const PwdReset = () => import('@/views/account/PasswordReset')
const AttivaAccount = () => import('@/views/account/ActivateAccount')

const StatoOrdini = () => import('@/views/ordini/StatoOrdini')
const ProfiloUtente = () => import('@/views/ProfiloUtente')
const Download = () => import('@/views/Download')
const RiepilogoMensile = () => import('@/views/RiepilogoMensile')
const Clienti = () => import('@/views/Clienti')
const Home = () => import('@/views/Home')
const ArticoliFor = () => import('@/views/fornitori/ArticoliFornitori')
const GoogleMaps = () => import('@/views/Google')
const PreventivoHome = () => import('@/views/preventivi/PreventivoHome')
const Preventivo = () => import('@/views/preventivi/Preventivo')
const Preventivi = () => import('@/views/preventivi/ListaPreventivi')
const Offerte = () => import('@/views/Offerte')
const Conferme = () => import('@/views/ordini/ConfermeOrdini')
const Statistiche = () => import('@/views/Statistiche')
const Obiettivi = () => import('@/views/Obiettivi')

const UserNew = () => import('@/views/admin/UserNew')
const UserAct = () => import('@/views/admin/UserActivity')
const Dashboard = () => import('@/views/admin/Dashboard')

const Resi = () => import("@/views/ordini/Resi.vue")

import storage from '@/services/storage.js'
import store from "@/store/index.js"


Vue.use(Router)

const routerOptions = [{
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/passwordreset',
    name: 'PasswordReset',
    component: PwdReset,
  },
  {
    path: '/activateaccount',
    name: 'AttivaAccount',
    component: AttivaAccount,
  },
  {
    path: '/',
    component: Main,
    meta: {
      checkAuth: true
    },
    children: [{
        path: '', // Default children
        component: Home,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'VisualizzaOrdini',
        component: RiepilogoMensile,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'profiloUtente',
        component: ProfiloUtente,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'download',
        component: Download,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'statoOrdini',
        component: StatoOrdini,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'clienti',
        component: Clienti,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'articoli',
        component: ArticoliFor,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'useractivity',
        component: UserAct,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'usernew',
        component: UserNew,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'maps',
        component: GoogleMaps,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'statistiche',
        component: Statistiche,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'obiettivi',
        component: Obiettivi,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'sceltaPreventivo',
        component: PreventivoHome,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'preventivi',
        component: Preventivi,
        meta: {
          checkAuth: true,
        },
        children: [],
      },
      {
        path: 'preventivo',
        component: Preventivo,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'offerte',
        component: Offerte,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'confermeordini',
        component: Conferme,
        meta: {
          checkAuth: true,
        }
      },
      {
        path: 'dashboard',
        component: Dashboard,
        meta: {
          checkAuth: true,
        }
      }, {
        path: 'nonconformita',
        component: Resi,
        meta: {
          checkAuth: true,
        }
      },
    ]
  },
  {
    path: '/doc',
    name: 'doc',
    component: Doc,

  },
  {
    path: "*", // Gestore pagine non trovate
    beforeEnter: (to, from, next) => {
      next({
        path: '/'
      })
    }
  }

]


const rou = new Router({
  mode: 'history',
  routes: routerOptions
})


rou.beforeEach((to, from, next) => {
  // Controllo richiesta autenticazione (se token non presente ritorno al login)
  if (to.meta.checkAuth && !storage.checkAuth()) {

    next({
      path: '/login'
    })
    return

  }
  // Controllo pagina login\registrazione (se è già autenticato vado alla pagina riservata)
  else if ((to.path == "/login" || to.path == "/register") && storage.checkAuth()) {

    next({
      path: '/'
    })
    return

  } else {
    // Controllo dialog

    if (to.path == "/dialogFile") {
      store.commit("app/SET_DIALOG", "fileFornitori");
      return
    } else if (to.path == "/dialogListaAgenti") {
      store.commit("app/SET_DIALOG", "sceltaAgenti");
      return
    } else if (to.path == "/dialogListaClienti") {
      store.commit("app/SET_DIALOG", "sceltaClienti");
      return
    }
  }

  next();
})


export default rou;